var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDalefon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-dalefon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dalefon",
    clipPath: "url(#clip-dalefon)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2113",
    "data-name": "Grupo 2113",
    transform: "translate(-19.666 12.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_782",
    "data-name": "Trazado 782",
    d: "M428.54,1540.793a4.156,4.156,0,0,0-5.117.761l-1.906,1.966-15,15.467-2.755,2.839c-.189-.038-.382-.069-.573-.106a32.475,32.475,0,0,0-21.5,3.148,33.962,33.962,0,0,0-7.133,5.027,36.146,36.146,0,0,0-11.59,26.719c0,.447.017.889.032,1.332.64,18.1,14.214,32.729,31.336,34.069.846.068,1.7.111,2.56.111a33.6,33.6,0,0,0,28.841-16.812,36.559,36.559,0,0,0,5.088-18.7c0-.027,0-.054,0-.08s0-.031,0-.049V1544.8A4.5,4.5,0,0,0,428.54,1540.793Z",
    transform: "translate(-327.231 -1548.481)",
    fill: "none",
    stroke: "#6c637b",
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDalefon);
export default __webpack_public_path__ + "static/media/dalefon.e35c75dbc633c5c61c52c08b72552421.svg";
export { ForwardRef as ReactComponent };